import React, { useMemo, useRef } from "react";
import { Card, Button } from "react-bootstrap";
import { StateFilter } from "./state-filter/StateFilter";
import { StateTable } from "./state-table/StateTable";
import { useStateUIContext } from "./StateUIContext";

export function StateCard({
  isLoading,
  handleAddNewState,
  handleFilterValues,
  stateList,
  handleReset,
  filterValues,
  currentPage,
  stateListTotalCount,
  setCurrentPage,
  countryList,
}) {
  const stateUIContext = useStateUIContext();
  const stateUIProps = useMemo(() => {
    return {
      ids: stateUIContext.ids,
      queryParams: stateUIContext.queryParams,
      setQueryParams: stateUIContext.setQueryParams,
      openReceiptDialog: stateUIContext.openReceiptDialog,
      openDeleteDialog: stateUIContext.openDeleteDialog,
      openEditDialog: stateUIContext.openEditDialog,
    };
  }, [stateUIContext]);
  const myRef = useRef(null);
  const onhandleReset = () => {
    myRef.current.click();
  };

  return (
    <>
      <Card className="card-custom card-stretch make-payment-wrapper">
        <Card.Header className="align-items-center border-bottom mt-4 d-none d-lg-flex">
          <h3 className="card-title align-items-start flex-column">
            <span className="font-weight-bold text-dark">States</span>
          </h3>
          <Button
            type="button"
            className="btn btn-secondary btn-lg"
            onClick={onhandleReset}
          >
            Reset
          </Button>
          <Button
            variant="btn btn-light-primary btn-lg "
            onClick={handleAddNewState}
          >
            Add New State
          </Button>
        </Card.Header>
        <Card.Body>
          <StateFilter
            filterValues={handleFilterValues}
            countryList={countryList}
            myRef={myRef} handleReset={handleReset}
          />
          <StateTable
            stateList={stateList}
            filterValues={filterValues}
            currentPage={currentPage}
            stateListTotalCount={stateListTotalCount}
            setCurrentPage={setCurrentPage}
            isLoading={isLoading}
          />
        </Card.Body>
      </Card>
    </>
  );
}
